import gql from "graphql-tag";

export const createCustomOdeContent = gql`
  mutation CreateCustomOdeContent($data: CustomOdeContentCreateInput!) {
    createCustomOdeContent(data: $data) {
      id
    }
  }
`;
